import { render, staticRenderFns } from "./ActivatePlan.vue?vue&type=template&id=4c5c72a0&scoped=true&"
import script from "./ActivatePlan.vue?vue&type=script&lang=js&"
export * from "./ActivatePlan.vue?vue&type=script&lang=js&"
import style0 from "./ActivatePlan.vue?vue&type=style&index=0&id=4c5c72a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5c72a0",
  null
  
)

export default component.exports